import {
  BellOutlined,
  BulbOutlined,
  GiftOutlined,
  InfoCircleOutlined,
  RobotOutlined,
  RocketOutlined,
  StarOutlined,
  WarningOutlined
} from '@ant-design/icons'
import * as React from 'react'

// The keys are Campaign::MANAGER_ICONS in app/models/campaign.rb.
const ICONS: Record<string, typeof RobotOutlined> = {
  robot: RobotOutlined,
  info: InfoCircleOutlined,
  bulb: BulbOutlined,
  gift: GiftOutlined,
  rocket: RocketOutlined,
  star: StarOutlined,
  bell: BellOutlined,
  warning: WarningOutlined
}

type Props = {
  id?: string
  className?: string
}

const CampaignIcon: React.FC<Props> = ({ id, className }) => {
  const Icon = id ? ICONS[id] : undefined
  if (!Icon) return null

  return <Icon className={className} aria-hidden />
}

export default CampaignIcon
